(ns nl.mediquest.be-my-coach-frontend.util)

(defn separate-scroll-context
  "Creates a wrapper around any body that fills the parent
  and provides a new scroll context"
  [& body]
  [:div.h-full.w-full.relative
   (into
    [:div.absolute.inset-0.overflow-auto.h-full]
    body)])
